import React from 'react';

type Props = {
  width?: number;
  height?: number;
};

const IconExcelFile: React.FC<Props> = ({ width = 24, height = 24 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2002 0.75H16.1895L22.6504 7.20996V20C22.6504 21.7949 21.1952 23.2499 19.4004 23.25H8.2002C6.40527 23.25 4.9502 21.7949 4.9502 20V4C4.9502 2.20508 6.40527 0.75 8.2002 0.75Z"
      fill="white"
      stroke="#D5D9DE"
      stroke-width="1.5"
    />
    <path
      d="M16.2002 0.300049V3.20005C16.2002 5.40919 17.9911 7.20005 20.2002 7.20005H23.1002"
      stroke="#D5D9DE"
      stroke-width="1.5"
    />
    <rect
      x="0.916504"
      y="12.1575"
      width="19.1668"
      height="9.6"
      rx="2"
      fill="#16B364"
    />
    <path
      d="M4.1772 14.7745L5.05717 16.2617H5.09126L5.9755 14.7745H7.0174L5.68572 16.9563L7.04723 19.1381H5.98615L5.09126 17.6488H5.05717L4.16229 19.1381H3.10547L4.47124 16.9563L3.13104 14.7745H4.1772Z"
      fill="white"
    />
    <path
      d="M7.60121 19.1381V14.7745H8.52379V18.3775H10.3945V19.1381H7.60121Z"
      fill="white"
    />
    <path
      d="M13.3727 16.0295C13.3556 15.8576 13.2825 15.7241 13.1532 15.6289C13.024 15.5337 12.8485 15.4862 12.627 15.4862C12.4764 15.4862 12.3493 15.5075 12.2456 15.5501C12.1419 15.5913 12.0623 15.6488 12.0069 15.7227C11.9529 15.7965 11.926 15.8803 11.926 15.9741C11.9231 16.0522 11.9395 16.1204 11.975 16.1786C12.0119 16.2369 12.0623 16.2873 12.1262 16.3299C12.1902 16.3711 12.264 16.4073 12.3478 16.4386C12.4316 16.4684 12.5211 16.494 12.6163 16.5153L13.0083 16.609C13.1987 16.6516 13.3734 16.7085 13.5325 16.7795C13.6916 16.8505 13.8294 16.9379 13.9458 17.0415C14.0623 17.1452 14.1525 17.2674 14.2164 17.408C14.2818 17.5487 14.3152 17.7099 14.3166 17.8917C14.3152 18.1587 14.247 18.3903 14.112 18.5863C13.9785 18.7809 13.7853 18.9322 13.5325 19.0401C13.2811 19.1467 12.9778 19.1999 12.6227 19.1999C12.2704 19.1999 11.9636 19.146 11.7022 19.038C11.4423 18.93 11.2392 18.7702 11.0929 18.5586C10.948 18.3455 10.872 18.082 10.8649 17.7681H11.7576C11.7676 17.9144 11.8095 18.0366 11.8833 18.1346C11.9586 18.2312 12.0588 18.3043 12.1838 18.354C12.3102 18.4023 12.4529 18.4265 12.612 18.4265C12.7683 18.4265 12.9039 18.4038 13.019 18.3583C13.1355 18.3129 13.2257 18.2496 13.2896 18.1687C13.3535 18.0877 13.3855 17.9947 13.3855 17.8896C13.3855 17.7915 13.3564 17.7092 13.2981 17.6424C13.2413 17.5756 13.1575 17.5188 13.0467 17.4719C12.9373 17.4251 12.8031 17.3825 12.644 17.3441L12.1689 17.2248C11.801 17.1353 11.5105 16.9954 11.2974 16.805C11.0843 16.6147 10.9785 16.3583 10.9799 16.0359C10.9785 15.7717 11.0488 15.5408 11.1909 15.3434C11.3343 15.146 11.5311 14.9918 11.7811 14.881C12.0311 14.7702 12.3152 14.7148 12.6333 14.7148C12.9572 14.7148 13.2399 14.7702 13.4814 14.881C13.7243 14.9918 13.9132 15.146 14.0481 15.3434C14.1831 15.5408 14.2527 15.7695 14.2569 16.0295H13.3727Z"
      fill="white"
    />
    <path
      d="M15.8022 14.7745L16.6822 16.2617H16.7163L17.6005 14.7745H18.6424L17.3107 16.9563L18.6722 19.1381H17.6111L16.7163 17.6488H16.6822L15.7873 19.1381H14.7305L16.0962 16.9563L14.756 14.7745H15.8022Z"
      fill="white"
    />
  </svg>
);

export default IconExcelFile;
